export const emojiCategories = {
    smileys: {
        name: "Smileys & People",
        emojis: [
            "😀",
            "😃",
            "😄",
            "😁",
            "😆",
            "😅",
            "😂",
            "🤣",
            "😊",
            "😇",
            "🙂",
            "🙃",
            "😉",
            "😌",
            "😍",
            "🥰",
            "😘",
            "😗",
            "😙",
            "😚",
            "😋",
            "😛",
            "😝",
            "😜",
            "🤪",
            "🤨",
            "🧐",
            "🤓",
            "😎",
            "🤩",
            "🥳",
            "😏",
            "😒",
            "😞",
            "😔",
            "😟",
            "😕",
            "🙁",
            "☹️",
            "😣",
            "😖",
            "😫",
            "😩",
            "🥺",
            "😢",
            "😭",
            "😤",
            "😠",
            "😡",
            "🤬",
            "🤯",
            "😳",
            "🥵",
            "🥶",
            "😱",
            "😨",
            "😰",
            "😥",
            "😓",
            "🤗",
            "🤔",
            "🤭",
            "🤫",
            "🤥",
            "😶",
            "😐",
            "😑",
            "😬",
            "🙄",
            "😯",
            "😦",
            "😧",
            "😮",
            "😲",
            "🥱",
            "😴",
            "🤤",
            "😪",
            "😵",
            "🤐",
            "🥴",
            "🤢",
            "🤮",
            "🤧",
            "😷",
            "🤒",
            "🤕",
        ],
    },
    animals: {
        name: "Animals & Nature",
        emojis: [
            "🐶",
            "🐱",
            "🐭",
            "🐹",
            "🐰",
            "🦊",
            "🐻",
            "🐼",
            "🐨",
            "🐯",
            "🦁",
            "🐮",
            "🐷",
            "🐽",
            "🐸",
            "🐵",
            "🙈",
            "🙉",
            "🙊",
            "🐒",
            "🐔",
            "🐧",
            "🐦",
            "🐤",
            "🐣",
            "🐥",
            "🦆",
            "🦅",
            "🦉",
            "🦇",
            "🐺",
            "🐗",
            "🐴",
            "🦄",
            "🐝",
            "🐛",
            "🦋",
            "🐌",
            "🐞",
            "🐜",
            "🦟",
            "🦗",
            "🕷️",
            "🕸️",
            "🦂",
            "🐢",
            "🐍",
            "🦎",
            "🦖",
            "🦕",
            "🐙",
            "🦑",
            "🦐",
            "🦞",
            "🦀",
            "🐡",
            "🐠",
            "🐟",
            "🐬",
            "🐳",
            "🐋",
            "🦈",
            "🐊",
            "🐅",
            "🐆",
            "🦓",
            "🦍",
            "🦧",
            "🐘",
            "🦛",
            "🦏",
            "🐪",
            "🐫",
            "🦒",
            "🦘",
            "🐃",
            "🐂",
            "🐄",
            "🐎",
            "🐖",
            "🐏",
            "🐑",
            "🦙",
            "🐐",
            "🦌",
            "🐕",
            "🐩",
            "🦮",
            "🐕‍🦺",
            "🐈",
            "🐓",
            "🦃",
            "🦚",
            "🦜",
            "🦢",
            "🦩",
            "🕊️",
            "🐇",
            "🦝",
            "🦨",
            "🦡",
            "🦦",
            "🦥",
            "🐁",
            "🐀",
            "🐿️",
        ],
    },
    food: {
        name: "Food & Drink",
        emojis: [
            "🍎",
            "🍐",
            "🍊",
            "🍋",
            "🍌",
            "🍉",
            "🍇",
            "🍓",
            "🫐",
            "🍈",
            "🍒",
            "🍑",
            "🥭",
            "🍍",
            "🥥",
            "🥝",
            "🍅",
            "🍆",
            "🥑",
            "🥦",
            "🥬",
            "🥒",
            "🌶️",
            "🫑",
            "🌽",
            "🥕",
            "🫒",
            "🧄",
            "🧅",
            "🥔",
            "🍠",
            "🥐",
            "🥯",
            "🍞",
            "🥖",
            "🥨",
            "🧀",
            "🥚",
            "🍳",
            "🧈",
            "🥞",
            "🧇",
            "🥓",
            "🥩",
            "🍗",
            "🍖",
            "🦴",
            "🌭",
            "🍔",
            "🍟",
            "🍕",
            "🫓",
            "🥪",
            "🥙",
            "🧆",
            "🌮",
            "🌯",
            "🫔",
            "🥗",
            "🥘",
            "🫕",
            "🥫",
            "🍝",
            "🍜",
            "🍲",
            "🍛",
            "🍣",
            "🍱",
            "🥟",
            "🦪",
            "🍤",
            "🍙",
            "🍚",
            "🍘",
            "🍥",
            "🥠",
            "🥮",
            "🍢",
            "🍡",
            "🍧",
            "🍨",
            "🍦",
            "🥧",
            "🧁",
            "🍰",
            "🎂",
            "🍮",
            "🍭",
            "🍬",
            "🍫",
            "🍿",
            "🍩",
            "🍪",
            "🌰",
            "🥜",
            "🍯",
        ],
    },
    activities: {
        name: "Activities",
        emojis: [
            "⚽",
            "🏀",
            "🏈",
            "⚾",
            "🥎",
            "🎾",
            "🏐",
            "🏉",
            "🥏",
            "🎱",
            "🪀",
            "🏓",
            "🏸",
            "🏒",
            "🏑",
            "🥍",
            "🏏",
            "🪃",
            "🥅",
            "⛳",
            "🪁",
            "🏹",
            "🎣",
            "🤿",
            "🥊",
            "🥋",
            "🎽",
            "🛹",
            "🛷",
            "⛸️",
            "🥌",
            "🎿",
            "⛷️",
            "🏂",
            "🪂",
            "🏋️‍♀️",
            "🏋️",
            "🏋️‍♂️",
            "🤼‍♀️",
            "🤼",
            "🤼‍♂️",
            "🤸‍♀️",
            "🤸",
            "🤸‍♂️",
            "⛹️‍♀️",
            "⛹️",
            "⛹️‍♂️",
            "🤺",
            "🤾‍♀️",
            "🤾",
            "🤾‍♂️",
            "🏌️‍♀️",
            "🏌️",
            "🏌️‍♂️",
            "🏇",
            "🧘‍♀️",
            "🧘",
            "🧘‍♂️",
            "🏄‍♀️",
            "🏄",
            "🏄‍♂️",
            "🏊‍♀️",
            "🏊",
            "🏊‍♂️",
            "🤽‍♀️",
            "🤽",
            "🤽‍♂️",
            "🚣‍♀️",
            "🚣",
            "🚣‍♂️",
            "🧗‍♀️",
            "🧗",
            "🧗‍♂️",
            "🚵‍♀️",
            "🚵",
            "🚵‍♂️",
            "🚴‍♀️",
            "🚴",
            "🚴‍♂️",
            "🏆",
            "🥇",
            "🥈",
            "🥉",
            "🏅",
            "🎖️",
            "🏵️",
            "🎗️",
            "🎫",
            "🎟️",
            "🎪",
            "🤹",
            "🤹‍♀️",
            "🤹‍♂️",
            "🎭",
            "🩰",
            "🎨",
            "🎬",
            "🎤",
            "🎧",
            "🎼",
            "🎵",
            "🎶",
            "🥁",
            "🪘",
            "🎹",
            "🎷",
            "🎺",
            "🪗",
            "🎸",
            "🪕",
            "🎻",
            "🎲",
            "♟️",
            "🎯",
            "🎳",
            "🎮",
            "🎰",
            "🧩",
        ],
    },
    objects: {
        name: "Objects",
        emojis: [
            "⌚",
            "📱",
            "📲",
            "💻",
            "⌨️",
            "🖥️",
            "🖨️",
            "🖱️",
            "🖲️",
            "🕹️",
            "🗜️",
            "💽",
            "💾",
            "💿",
            "📀",
            "📼",
            "📷",
            "📸",
            "📹",
            "🎥",
            "📽️",
            "🎞️",
            "📞",
            "☎️",
            "📟",
            "📠",
            "📺",
            "📻",
            "🎙️",
            "🎚️",
            "🎛️",
            "🧭",
            "⏱️",
            "⏲️",
            "⏰",
            "🕰️",
            "⌛",
            "⏳",
            "📡",
            "🔋",
            "🔌",
            "💡",
            "🔦",
            "🕯️",
            "🪔",
            "🧯",
            "🛢️",
            "💸",
            "💵",
            "💴",
            "💶",
            "💷",
            "🪙",
            "💰",
            "💳",
            "💎",
            "⚖️",
            "🪜",
            "🧰",
            "🔧",
            "🔨",
            "⚒️",
            "🛠️",
            "⛏️",
            "🪓",
            "🪚",
            "🔩",
            "⚙️",
            "🪤",
            "🧱",
            "⛓️",
            "🧲",
            "🔫",
            "💣",
            "🧨",
            "🪓",
            "🔪",
            "🗡️",
            "⚔️",
            "🛡️",
            "🚬",
            "⚰️",
            "🪦",
            "⚱️",
            "🏺",
            "🔮",
            "📿",
            "🧿",
            "💈",
            "⚗️",
            "🔭",
            "🔬",
            "🕳️",
            "🩹",
            "🩺",
            "💊",
            "💉",
            "🩸",
            "🧬",
            "🦠",
            "🧫",
            "🧪",
            "🌡️",
            "🧹",
            "🪣",
            "🧽",
            "🧴",
            "🛎️",
            "🔑",
            "🗝️",
            "🚪",
            "🪑",
            "🛋️",
            "🛏️",
            "🛌",
            "🧸",
            "🪆",
            "🖼️",
            "🪞",
            "🪟",
            "🛍️",
            "🛒",
            "🎁",
            "🎈",
            "🎏",
            "🎀",
            "🪄",
            "🪅",
            "🎊",
            "🎉",
            "🎎",
            "🏮",
            "🎐",
            "🧧",
            "✉️",
            "📩",
            "📨",
            "📧",
            "💌",
            "📥",
            "📤",
            "📦",
            "🏷️",
            "🪧",
            "📪",
            "📫",
            "📬",
            "📭",
            "📮",
            "📯",
            "📜",
            "📃",
            "📄",
            "📑",
            "🧾",
            "📊",
            "📈",
            "📉",
            "🗒️",
            "🗓️",
            "📆",
            "📅",
            "🗑️",
            "📇",
            "🗃️",
            "🗳️",
            "🗄️",
            "📋",
            "📁",
            "📂",
            "🗂️",
            "🗞️",
            "📰",
            "📓",
            "📔",
            "📒",
            "📕",
            "📗",
            "📘",
            "📙",
            "📚",
            "📖",
            "🔖",
            "🧷",
            "🔗",
            "📎",
            "🖇️",
            "📐",
            "📏",
            "🧮",
            "📌",
            "📍",
            "✂️",
            "🖊️",
            "🖋️",
            "✒️",
            "🖌️",
            "🖍️",
            "📝",
            "✏️",
            "🔍",
            "🔎",
            "🔏",
            "🔐",
            "🔒",
            "🔓",
        ],
    },
    symbols: {
        name: "Symbols",
        emojis: [
            "❤️",
            "🧡",
            "💛",
            "💚",
            "💙",
            "💜",
            "🖤",
            "🤍",
            "🤎",
            "💔",
            "❣️",
            "💕",
            "💞",
            "💓",
            "💗",
            "💖",
            "💘",
            "💝",
            "💟",
            "☮️",
            "✝️",
            "☪️",
            "🕉️",
            "☸️",
            "✡️",
            "🔯",
            "🕎",
            "☯️",
            "☦️",
            "🛐",
            "⛎",
            "♈",
            "♉",
            "♊",
            "♋",
            "♌",
            "♍",
            "♎",
            "♏",
            "♐",
            "♑",
            "♒",
            "♓",
            "🆔",
            "⚛️",
            "🉑",
            "☢️",
            "☣️",
            "📴",
            "📳",
            "🈶",
            "🈚",
            "🈸",
            "🈺",
            "🈷️",
            "✴️",
            "🆚",
            "💮",
            "🉐",
            "㊙️",
            "㊗️",
            "🈴",
            "🈵",
            "🈶",
            "🈚",
            "🈸",
            "🈺",
            "🈷️",
            "✴️",
            "🆚",
            "💮",
            "🉐",
            "㊙️",
            "㊗️",
            "🈴",
            "🈵",
            "🈹",
            "🈲",
            "🅰️",
            "🅱️",
            "🆎",
            "🆑",
            "🅾️",
            "🆘",
            "❌",
            "⭕",
            "🛑",
            "⛔",
            "📛",
            "🚫",
            "💯",
            "💢",
            "♨️",
            "🚷",
            "🚯",
            "🚳",
            "🚱",
            "🔞",
            "📵",
            "🚭",
            "❗",
            "❕",
            "❓",
            "❔",
            "‼️",
            "⁉️",
            "🔅",
            "🔆",
            "〽️",
            "⚠️",
            "🚸",
            "🔱",
            "⚜️",
            "🔰",
            "♻️",
            "✅",
            "🈯",
            "💹",
            "❇️",
            "✳️",
            "❎",
            "🌐",
            "💠",
            "Ⓜ️",
            "🌀",
            "💤",
            "🏧",
            "🚾",
            "♿",
            "🅿️",
            "🛗",
            "🈳",
            "🈂️",
            "🛂",
            "🛃",
            "🛄",
            "🛅",
            "🚹",
            "🚺",
            "🚼",
            "⚧️",
            "🚻",
            "🚮",
            "🎦",
            "📶",
            "🈁",
            "🔣",
            "ℹ️",
            "🔤",
            "🔡",
            "🔠",
            "🆖",
            "🆗",
            "🆙",
            "🆒",
            "🆕",
            "🆓",
            "0️⃣",
            "1️⃣",
            "2️⃣",
            "3️⃣",
            "4️⃣",
            "5️⃣",
            "6️⃣",
            "7️⃣",
            "8️⃣",
            "9️⃣",
            "🔟",
            "🔢",
            "#️⃣",
            "*️⃣",
            "⏏️",
            "▶️",
            "⏸️",
            "⏯️",
            "⏹️",
            "⏺️",
            "⏭️",
            "⏮️",
            "⏩",
            "⏪",
            "⏫",
            "⏬",
            "◀️",
            "🔼",
            "🔽",
            "➡️",
            "⬅️",
            "⬆️",
            "⬇️",
            "↗️",
            "↘️",
            "↙️",
            "↖️",
            "↕️",
            "↔️",
            "↪️",
            "↩️",
            "⤴️",
            "⤵️",
            "🔀",
            "🔁",
            "🔂",
            "🔄",
            "🔃",
            "🎵",
            "🎶",
            "➕",
            "➖",
            "➗",
            "✖️",
            "🟰",
            "♾️",
            "💲",
            "💱",
            "™️",
            "©️",
            "®️",
            "〰️",
            "➰",
            "➿",
            "🔚",
            "🔙",
            "🔛",
            "🔝",
            "🔜",
            "✔️",
            "☑️",
            "🔘",
            "🔴",
            "🟠",
            "🟡",
            "🟢",
            "🔵",
            "🟣",
            "⚫",
            "⚪",
            "🟤",
            "🔺",
            "🔻",
            "🔸",
            "🔹",
            "🔶",
            "🔷",
            "🔳",
            "🔲",
            "▪️",
            "▫️",
            "◾",
            "◽",
            "◼️",
            "◻️",
            "🟥",
            "🟧",
            "🟨",
            "🟩",
            "🟦",
            "🟪",
            "⬛",
            "⬜",
            "🟫",
            "🔈",
            "🔇",
            "🔉",
            "🔊",
            "🔔",
            "🔕",
            "📣",
            "📢",
            "👁️‍🗨️",
            "💬",
            "💭",
            "🗯️",
            "♠️",
            "♣️",
            "♥️",
            "♦️",
            "🃏",
            "🎴",
            "🀄",
            "🕐",
            "🕑",
            "🕒",
            "🕓",
            "🕔",
            "🕕",
            "🕖",
            "🕗",
            "🕘",
            "🕙",
            "🕚",
            "🕛",
            "🕜",
            "🕝",
            "🕞",
            "🕟",
            "🕠",
            "🕡",
            "🕢",
            "🕣",
            "🕤",
            "🕥",
            "🕦",
            "🕧",
        ],
    },
};
